import { useDispatch } from 'react-redux';
import { ToolbarState } from '../toolbarTypes';
import { useEffect } from 'react';

export const CURRENT_TOOLBAR_UPDATED = 'CURRENT_TOOLBAR_UPDATED';

/**
 * Dispatches an action to report the current toolbar state to the redux store
 * Note: Toolbar state isn't stored in redux, so this effectively does nothing but is used for onboarding step progression
 */
const useToolbarReduxReporting = (toolbarState: ToolbarState) => {
    const dispatch = useDispatch();

    const currentToolbar = toolbarState.toolbars[toolbarState.focusIndex];

    useEffect(() => {
        dispatch({ type: CURRENT_TOOLBAR_UPDATED, currentToolbar });
    }, [currentToolbar]);
};

export default useToolbarReduxReporting;
